import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { catchError, Observable, retry, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReporteriaService {
  private sUrlNomina: string ='';
  constructor(private http: HttpClient) {
    this.sUrlNomina = environment.sUrlNomina + 'Reporteria';
  }


getrptfaltas( idCiudad :number, fec_inicio: string, fec_fin: string):Observable<any[]>{
  const valores ={
        params: new HttpParams().
            set('id_ciudad_hm', idCiudad)
            .set('fec_inicio', fec_inicio)
            .set('fec_fin', fec_fin)
            // .set('num_anio', num_anio)
  };
  return this.http.get<any[]>(this.sUrlNomina +'/getrptfaltas',valores )
   .pipe(retry(1), catchError(this.handleError))


}

getrptasistenciapagada( idCiudad :number, fec_inicio: string, fec_fin: string):Observable<any[]>{
  const valores ={
        params: new HttpParams().
            set('id_ciudad_hm', idCiudad)
            .set('fec_inicio', fec_inicio)
            .set('fec_fin', fec_fin)
            // .set('num_anio', num_anio)
  };
  return this.http.get<any[]>(this.sUrlNomina +'/getrptasistenciapagada',valores )
   .pipe(retry(1), catchError(this.handleError))


}

getrpdescansolab( idCiudad :number, fec_inicio: string, fec_fin: string):Observable<any[]>{
  const valores ={
        params: new HttpParams().
            set('id_ciudad_hm', idCiudad)
            .set('fec_inicio', fec_inicio)
            .set('fec_fin', fec_fin)
            // .set('num_anio', num_anio)
  };
  return this.http.get<any[]>(this.sUrlNomina +'/rptdesclabo',valores )
   .pipe(retry(1), catchError(this.handleError))


}



getrptextension( idCiudad :number, fec_inicio: string, fec_fin: string):Observable<any[]>{
  const valores ={
        params: new HttpParams().
            set('id_ciudad_hm', idCiudad)
            .set('fec_inicio', fec_inicio)
            .set('fec_fin', fec_fin)
            // .set('num_anio', num_anio)
  };
  return this.http.get<any[]>(this.sUrlNomina +'/rptextension',valores )
   .pipe(retry(1), catchError(this.handleError))
}

getrptServiciosNomina( id_semana: number, num_anio: number, idCiudad: number):Observable<any[]>{
  const valores ={
        params: new HttpParams().
            set('id_semana', id_semana)
            .set('num_anio', num_anio)
            .set('id_ciudad_hm', idCiudad)
            // .set('num_anio', num_anio)
  };
  return this.http.get<any[]>(this.sUrlNomina +'/rptServiciosNomina',valores )
   .pipe(retry(1), catchError(this.handleError))
}

// rpteEchamelaMano( id_ciudad_hm :number, fec_inicio: string, fec_fin: string,  num_anio :number):Observable<any[]>{
//   const valores = {
//     params: new HttpParams()
//       .set('num_anio', num_anio_rpt)
//       .set('id_semana', id_semana_rpt)
//       .set('id_ciudad_hm', id_ciudad_hm_rpt)
//   };
//   return this.http.get<any>(this.apiUrl + '/rptechamelaMano', valores)
//     .pipe(retry(1), catchError(this.handleError));
// }


  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
